import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import SectionRenderer from './SectionRenderer';

const DEFAULT_ORDER = ['hero', 'projects', 'skills', 'about', 'experience', 'contact'];

const GridShowcaseLayout = ({ siteConfig }) => {
  const order = Array.isArray(siteConfig?.sectionOrder) && siteConfig.sectionOrder.length
    ? siteConfig.sectionOrder
    : DEFAULT_ORDER;
  const visibility = siteConfig?.sectionVisibility || {};

  return (
    <div className="theme-layout-grid-showcase">
      <Header />
      <main className="theme-grid-showcase-main">
        {order.map((sectionKey, index) => {
          if (visibility[sectionKey] === false) {
            return null;
          }

          return (
            <section
              key={sectionKey}
              className={`theme-grid-showcase-section ${index === 0 ? 'theme-grid-showcase-hero' : ''}`}
            >
              <SectionRenderer sectionKey={sectionKey} />
            </section>
          );
        })}
      </main>
      {visibility.footer !== false && <Footer />}
    </div>
  );
};

export default GridShowcaseLayout;
